import { useAxios } from '@/hooks/useAxios';
import { useQuery } from '@/utils/api';

export interface ClientPluginUsage {
  plugin: string;
  client: string;
  limit: number;
  totalUsed: number;
  remaining: number;
  lastRun: string;
  headroom: number;
}

export function useClientPluginUsage(
  client: string,
  plugin: string,
  enabled = true
) {
  const axios = useAxios({ doNotImpersonate: true });

  return useQuery<ClientPluginUsage>({
    defaultErrorMessage: 'Failed to fetch client plugin usage',
    queryKey: ['enrichment', plugin, 'usage', client],
    enabled: enabled && !!client && !!plugin,
    queryFn: async () => {
      const { data } = await axios.get(`/enrichment/${plugin}`, {
        params: { client },
      });
      return data;
    },
  });
}

export function useAllClientPluginUsage(
  client: string,
  plugins: string[],
  enabled = true
) {
  const axios = useAxios({ doNotImpersonate: true });

  return useQuery<ClientPluginUsage[]>({
    defaultErrorMessage: 'Failed to fetch client usage data',
    queryKey: ['enrichment', 'all-usage', client, plugins.join(',')],
    enabled: enabled && !!client && plugins.length > 0,
    queryFn: async () => {
      const settled = await Promise.allSettled(
        plugins.map(async plugin => {
          const { data } = await axios.get(`/enrichment/${plugin}`, {
            params: { client },
          });
          return data as ClientPluginUsage;
        })
      );
      return settled
        .filter(
          (r): r is PromiseFulfilledResult<ClientPluginUsage> =>
            r.status === 'fulfilled'
        )
        .map(r => r.value);
    },
  });
}
